<template>
    <h2>
        {{message}}
    </h2>
</template>

<script>
export default {
  name: 'TextHeader',
  props: {
    msg: String,
  },
  data() {
    return {
      message: this.msg,
    };
  },
};
</script>
<style scope>
h2 {
  padding-top: 50px;
  /* color: #4D3819; */
}
</style>
